// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1BwRj","card":"Cards_card__2v_X3","infected":"Cards_infected__3o4sA","recovery":"Cards_recovery__1OLjA","death":"Cards_death__1Kkhu"};